<template>
  <svg
    class="svg-icon"
    :class="className"
    xmlns="http://www.w3.org/2000/svg"
    @click.prevent="$emit('click:icon', $event)"
    :fill="iconFill"
  >
    <title v-if="title">{{ title }}</title>
    <slot name="additionalContent"></slot>
    <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
import('@/styles/elements/svg-icon.less')

export default {
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      required: false
    },
    width: {
      type: Number,
      required: false
    },
    fill: {
      type: String,
      required: false
    }
  },
  mounted() {
    if (this.width) this.$el.style.width = this.width + 'px'
    if (this.height) this.$el.style.height = this.height + 'px'
  },
  computed: {
    iconPath() {
      let icon = require(`@/assets/icon/${this.name}.svg`)
      if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
        icon = icon.default
      }
      return icon.url
    },
    className() {
      let strRes = 'svg-icon--' + this.name
      if (this.isDisabled) strRes += ' disabled'
      return strRes
    },
    iconFill() {
      return this.fill ? this.fill : '#3F4156'
    }
  }
}
</script>
